/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { ajax } from 'rxjs/ajax';
import { concat, of } from 'rxjs';
import { switchMap, filter, catchError, map } from 'rxjs/operators';
import { ofType } from 'redux-observable';

import { STATUS } from 'sarsaparilla';

import { getPricingViewUrl } from '../api/endpoints';

import {
    FETCH_PRICING_VIEW,
    fetchPricingViewSuccess,
    fetchPricingViewError,
    setFetchPricingViewStatus,
} from '../actions/pricingViewActions';

/**
 * Fetch the pricing view for a given facilityId
 */
export const fetchPricingView = (actions$) =>
    actions$.pipe(
        ofType(FETCH_PRICING_VIEW),
        filter(({ payload }) => !!payload),
        switchMap(({ payload: facilityId }) => {
            return concat(
                of(setFetchPricingViewStatus(STATUS.PENDING)),
                ajax.getJSON(getPricingViewUrl(facilityId)).pipe(
                    map((response) => {
                        const data = {
                            facilityId: response?.facility_id,
                            pricesByCategory: response?.tour_pricings_by_sales_category,
                        };
                        return fetchPricingViewSuccess(data);
                    }),
                    catchError((error) => of(fetchPricingViewError(error)))
                )
            );
        })
    );
